import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const GA_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY;
const GA_ENT_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ENT_KEY;
const HOSTNAME = import.meta.env.VITE_HOST_NAME;


const domain = window.location.hostname;

const GET_GA_ID = domain === HOSTNAME ? GA_ENT_ID : GA_ID;

const GA_MEASUREMENT_ID = GET_GA_ID;


declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const useGoogleAnalytics = (userId?: string) => {
  const location = useLocation();

  useEffect(() => {
    // Load GA script once
    if (!document.querySelector("#ga-script")) {
      const script = document.createElement("script");
      script.id = "ga-script";
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      // console.log("script", script.src);

      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };

      window.gtag("js", new Date());
      window.gtag("config", GA_MEASUREMENT_ID, {
        debug_mode: process.env.NODE_ENV !== "production",
      });
    }
  }, []);

  useEffect(() => {
    // Send page_view on route change
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        environment: process.env.NODE_ENV,
        ...(userId ? { user_id: userId } : {}),
      });
      // console.log("location",location.pathname);
      // console.log("process.env.NODE_ENV",process.env.NODE_ENV);

    }
  }, [location.pathname, userId]);

  // useEffect(() => {
  //   const start = Date.now();

  //   // Scroll tracking (fire once)
  //   // let hasScrolled = false;
  //   // const handleScroll = () => {
  //   //   if (!hasScrolled) {
  //   //     hasScrolled = true;
  //   //     if (typeof window.gtag === "function") {
  //   //       window.gtag("event", "user_scrolled", {
  //   //         page_path: location.pathname,
  //   //         environment: process.env.NODE_ENV,
  //   //         ...(userId ? { user_id: userId } : {}),
  //   //       });
  //   //     }
  //   //   }
  //   // };

  //   // Time on page tracking
  //   // const handleVisibilityChange = () => {
  //   //   if (document.visibilityState === "hidden") {
  //   //     const durationSeconds = Math.round((Date.now() - start) / 1000);
  //   //     if (typeof window.gtag === "function") {
  //   //       window.gtag("event", "time_on_page", {
  //   //         duration_seconds: durationSeconds,
  //   //         page_path: location.pathname,
  //   //         environment: process.env.NODE_ENV,
  //   //         ...(userId ? { user_id: userId } : {}),
  //   //       });
  //   //     }
  //   //   }
  //   // };

  //   // window.addEventListener("scroll", handleScroll, { once: true });
  //   // document.addEventListener("visibilitychange", handleVisibilityChange);

  //   // return () => {
  //   //   window.removeEventListener("scroll", handleScroll);
  //   //   document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   // };
  // }, [location.pathname, userId]);
};

export default useGoogleAnalytics